import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSetSessionRepository } from '@/modules/auth/infra/repositories'
import type { SetSession } from '@/modules/auth/use-cases'

export function makeSetSession(): SetSession {
  return new SupabaseSetSessionRepository(makeSupabaseClient()).execute
}
